// extracted by css-extract-rspack-plugin
export default {"container":"_66d92a11","price":"_e5da531b","purchase":"_3a7e9d"};